import {setLanguage} from './reducer';
import {LanguageItemProps} from '../../../interfaces/reducers/languageItem';
import {store} from '../../../redux/store';

export const saveLanguage = (language: LanguageItemProps) => {
  store.dispatch(
    setLanguage({
      language,
    }),
  );
};
